import { render, staticRenderFns } from "./activateCoupon.vue?vue&type=template&id=16451a74&scoped=true&"
import script from "./activateCoupon.vue?vue&type=script&lang=js&"
export * from "./activateCoupon.vue?vue&type=script&lang=js&"
import style0 from "./activateCoupon.vue?vue&type=style&index=0&id=16451a74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16451a74",
  null
  
)

export default component.exports